import React from "react";
import { MoreVertical } from "lucide-react";
import { IconButton } from "../../atoms/IconButton";
import { ActionMenu } from "../ActionMenu";
import { useRowActionMenuInternalState } from "./useRowActionMenuInternalState";
import type { RowActionMenuProps } from "./RowActionMenu.types";

/** Kebab trigger + ActionMenu for a table or list row. */
export const RowActionMenu: React.FC<RowActionMenuProps> = ({
  items,
  "aria-label": ariaLabel,
  menuLabel,
  minMenuWidth,
  align,
  className,
  icon = MoreVertical,
  iconColor,
  maxHeight,
  highlightFirst,
  density,
  showScrollbar,
  bordered,
  focusStyle,
  soonAlign,
  triggerSize = "sm",
}) => {
  const { isOpen, onClose, onToggle, onAction, triggerRef, menuRef, rect } =
    useRowActionMenuInternalState(items, maxHeight);
  return (
    <ActionMenu
      items={items}
      onAction={onAction}
      isOpen={isOpen}
      onClose={onClose}
      menuRef={menuRef}
      menuRect={rect}
      ariaLabel={menuLabel ?? ariaLabel}
      minMenuWidth={minMenuWidth}
      align={align}
      iconColor={iconColor}
      highlightFirst={highlightFirst}
      density={density}
      showScrollbar={showScrollbar}
      autoFocus
      focusStyle={focusStyle}
      soonAlign={soonAlign}
      trigger={
        <IconButton
          ref={triggerRef}
          icon={icon}
          aria-label={ariaLabel}
          aria-haspopup="menu"
          aria-expanded={isOpen}
          size={triggerSize}
          active={isOpen}
          bordered={bordered}
          className={className}
          onClick={onToggle}
        />
      }
    />
  );
};

export default RowActionMenu;
